<template>
  <div class="index-index-container">
    <div class="index-index-send" v-if="!repectFileStatus">
      <div class="index-send-title">揽件回执</div>
      <div class="index-send-none">
        <span>暂无揽件信息，请耐心等待</span>
        <span>当快递员揽件后，我们会反馈揽件信息</span>
      </div>
      <div class="index-send-button">
        <van-button class="button" round @click="onCancel">我知道了</van-button>
      </div>
    </div>
    <div class="index-index-send" v-if="repectFileStatus">
      <div class="index-send-title">揽件回执<span>已揽件</span></div>
      <ul class="index-send-tips">
        <li><p>揽件时间：</p><span>{{repectFileInfo.time}}</span></li>
        <li><p>揽件公司：</p><span>{{repectFileInfo.context}}</span></li>
      </ul>
      <div class="index-send-button">
        <van-button class="button" round @click="onCancel">我知道了</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    repectFileInfo: { type: Object, default: function () { return {} } },
    repectFileStatus: { type: Boolean, default: function () { return false } }
  },
  methods: {
    onCancel() {
      this.$emit('cancelRepect')
    }
  },
}
</script>

<style lang="less" scoped>
.index-index-container{
  display: block;
  .index-index-send{
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    .index-send-title{
      position: relative;
      display: flex;
      align-items: center;
      height: 106px;
      font-size: 32px;
      font-weight: bolder;
      span{
        color: #F8A651;
        font-size: 26px;
        font-weight: normal;
        position: absolute;
        right: 50px;
      }
    }
    .index-send-none{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 300px;
      span{
        font-size: 26px;
        color: #999999;
      }
    }
    .index-send-tips{
      display: flex;
      flex-direction: column;
      li{
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        p{
          font-size: 26px;
          color: #333333;
        }
        span{
          font-size: 26px;
          color: #999999;
        }
      }
    }
    .index-send-button{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 40px 20px;
      .button{
        width: 100%;
        height: 70px;
        font-size: 24px;
        font-weight: bolder;
        background: var(--epButtonColor);
        color: var(--epTextColor);
      }
    }
  }
}
</style>